// extracted by mini-css-extract-plugin
export default {"tooltip":"Rm-z","sharingV2":"Sm-z","sharingIconsV2":"Tm-z","links":"Um-z","link":"Vm-z","facebookV2":"Wm-z","twitterV2":"Xm-z","pinterestV2":"Ym-z"};